/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTranslationsByKeys } from '../fn/translation/get-translations-by-keys';
import { GetTranslationsByKeys$Params } from '../fn/translation/get-translations-by-keys';
import { getTranslationsByLanguage } from '../fn/translation/get-translations-by-language';
import { GetTranslationsByLanguage$Params } from '../fn/translation/get-translations-by-language';
import { Translation } from '../models/translation';

@Injectable({ providedIn: 'root' })
export class TranslationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTranslationsByLanguage()` */
  static readonly GetTranslationsByLanguagePath = '/api/public/ui-translations/{language}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTranslationsByLanguage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslationsByLanguage$Response(params: GetTranslationsByLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: string;
}>> {
    return getTranslationsByLanguage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTranslationsByLanguage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslationsByLanguage(params: GetTranslationsByLanguage$Params, context?: HttpContext): Observable<{
[key: string]: string;
}> {
    return this.getTranslationsByLanguage$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: string;
}>): {
[key: string]: string;
} => r.body)
    );
  }

  /** Path part for operation `getTranslationsByKeys()` */
  static readonly GetTranslationsByKeysPath = '/api/public/ui-translations/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTranslationsByKeys()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslationsByKeys$Response(params: GetTranslationsByKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Translation>>> {
    return getTranslationsByKeys(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTranslationsByKeys$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslationsByKeys(params: GetTranslationsByKeys$Params, context?: HttpContext): Observable<Array<Translation>> {
    return this.getTranslationsByKeys$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Translation>>): Array<Translation> => r.body)
    );
  }

}
